var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"PaB-money"},[_vm._v("\n  "+_vm._s(_vm.dollars)),(_vm.cents)?_c('span',{staticClass:"PaB-money__cents"},[_vm._v(_vm._s(_vm.cents))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }